<template>
    <div class="app-container" style="background:#f9f9f9">
        <!-- 工具搜索栏 -->
        <toolbar ref="toolbar" source="recycle" @filterSubmit="handleFilter"></toolbar>

        <!-- 文件列表 -->
        <file-list ref="fileList" source="recycle" :sourceList="fileList" :isShowHeader="false" :pageSize="pageSize" @handleFilter="handleFilter"  @refreshList="getList"></file-list>

    </div>
</template>

<script>
import Toolbar from './components/toolbar.vue'
import FileList from './components/fileList'
import {searchList_ajax} from '@File~/api/file'
export default {
    components: {Toolbar,FileList},
    data() {
        return {
            isRecycle:false,
            fileList:[],
            pageSize:18,
        }
    },

    mounted() {
        this.getList()
    },

    methods: {

        // 获取列表
        getList() {
            const toolbar = this.$refs['toolbar'] // 筛选条件
            const file = this.$refs['fileList']

            file.loading = true

            const data = {
                pageNo: file.listQuery.pageNo,
                pageSize:this.pageSize,
                keyword: toolbar.search, // 模糊搜索词条
                createTime:toolbar.createTime && toolbar.createTime.length > 0 ? toolbar.createTime[0] + ' - ' + toolbar.createTime[1] : '',
                folderPid:0,
                showType: 2,
                containsChildren:0,
                fileStatus: 0,
                inOut:this.$store.getters.synchro,
            }
            searchList_ajax(data).then(response => {
                file.loading = false
                if(response.code == 1) {
                    const data = JSON.parse(JSON.stringify(response.data.result))
                    this.fileList = data.map(v => {
                        this.$set(v, 'isMark', false)
                        return v
                    })
                    file.total = response.data.totalCount
                }
            })
        },

        // 查询
        handleFilter() {
            console.log('查询===')
            this.$refs['fileList'].listQuery.pageNo = 1
            this.getList()
        }
    }
}
</script>

<style lang="scss" scoped>
    .butn-container{
        margin-bottom: 10px;
    }
</style>